export enum LevelOfCoverAdditionalFields {
    HirePeriod = 'HirePeriod',
    HirePeriodUnit = 'HirePeriodUnit',
    RentalGuarantee = 'RentalGuarantee'
}